function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

var configureStore = function configureStore(_ref) {
  var reducer = _ref.reducer,
      initialState = _ref.initialState,
      _ref$middleware = _ref.middleware,
      middleware = _ref$middleware === void 0 ? [thunk] : _ref$middleware;
  return createStore(reducer, initialState, applyMiddleware.apply(void 0, _toConsumableArray(middleware)));
};

export default configureStore;